const queries = {
  loginSettings: () => ['login-settings'],
}

export default queries
